import { generateID } from './PanelTemplatesTheme/helpers';
import { WIDGET_LABEL_SIZE } from '../../components/Widget/WidgetLabel/constants';
import { Panel } from '../../models/Panel/Panel';

export var TemplateEditorial3: Panel = {
    id: 'editorial-3',
    name: 'Left Aligned Image w/ Text',
    description: '',
    tags: ['Editorial', 'text', 'image', 'landscape', 'portrait', 'interstitial'],
    widget: {
        id: generateID(),
        position: {
            width: '1920px',
            height: '1080px',
            top: '0',
            left: '0',
        },
        classes: 'template_custom',
        label: {
            titleText: 'Panel',
            enabled: false,
            size: WIDGET_LABEL_SIZE.primary,
        },
        children: [
            {
                type: 'customContentImage',
                id: generateID(),
                name: 'Image',
                position: {
                    width: '50%',
                    height: '100%',
                    top: '0',
                    left: '0',
                    portrait: {
                        width: '100%',
                        height: '50%',
                        top: '0',
                        left: '0',
                    },
                },
                label: {
                    titleText: 'Header',
                    enabled: false,
                    size: WIDGET_LABEL_SIZE.primary,
                },
                options: {
                    player: {
                        playing: false,
                        duration: 15,
                    },
                    contentImageFit: 'cover',
                    contentImageUrl: '/public/assets/MomentofDiscovery2.jpg',
                    horizontalAlign: 'right',
                },
            },
            {
                type: 'customContentRichText',
                name: 'Rich Text',
                id: generateID(),
                position: {
                    width: '40%',
                    height: '15%',
                    top: '10%',
                    left: '55%',
                    portrait: {
                        width: '80%',
                        height: '8%',
                        top: '55%',
                        left: '10%',
                    },
                },
                label: {
                    titleText: 'Widget Header',
                    enabled: false,
                    size: WIDGET_LABEL_SIZE.primary,
                },
                options: {
                    player: {
                        playing: false,
                        duration: 15,
                    },
                    contentRichText: {
                        entityMap: {},
                        blocks: [
                            {
                                key: 'ag6qs',
                                text: 'Main Header',
                                type: 'unstyled',
                                depth: 0,
                                inlineStyleRanges: [
                                    {
                                        offset: 0,
                                        length: 11,
                                        style: 'BOLD',
                                    },
                                    {
                                        offset: 0,
                                        length: 11,
                                        style: 'CUSTOM_FONT_SIZE_20' as any,
                                    },
                                ],
                                entityRanges: [],
                                data: {},
                            },
                        ],
                    },
                    contentPadding: 5,
                    contentTextAlign: 'left',
                    verticalAlign: 'top',
                },
            },
            {
                type: 'customContentRichText',
                name: 'Rich Text',
                id: generateID(),
                position: {
                    width: '40%',
                    height: '15%',
                    top: '23%',
                    left: '55%',
                    portrait: {
                        width: '80%',
                        height: '8%',
                        top: '63%',
                        left: '10%',
                    },
                },
                label: {
                    titleText: 'Widget Header',
                    enabled: false,
                    size: WIDGET_LABEL_SIZE.primary,
                },
                options: {
                    player: {
                        playing: false,
                        duration: 15,
                    },
                    contentRichText: {
                        entityMap: {},
                        blocks: [
                            {
                                key: 'ag6qs1',
                                text: 'Subheader',
                                type: 'unstyled',
                                depth: 0,
                                inlineStyleRanges: [
                                    {
                                        offset: 0,
                                        length: 9,
                                        style: 'CUSTOM_FONT_SIZE_18',
                                    },
                                ],
                                entityRanges: [],
                                data: {},
                            },
                        ],
                    },
                    contentPadding: 5,
                    contentTextAlign: 'left',
                    verticalAlign: 'top',
                },
            },
        ],
    },
};
